import React from 'react';
import { toast as reactToast} from 'react-toastify';
import styled, { ThemeProvider } from 'styled-components';
import { Close } from 'components/Icons';
import I18n from 'services/i18n';
import { appTheme } from 'theme';

const Wrapper = styled.div`
    padding-left: 20px;
`;

const ErrorCode = styled.div`
    margin-bottom: 8px;
`;

const Message = styled.div`
    font-size: ${({ theme }) => theme.typography.fontSizeM}px;
    font-weight: ${({ theme }) => theme.typography.fontWeight.light};
`;

interface IToastProps {
    toastMessage: string;
    errorCode?: number;
    type?: 'error' | 'info'
}

export const toast = ({ errorCode, toastMessage, type = 'error' }: IToastProps) => {
    return reactToast(
        <ThemeProvider theme={appTheme}>
            <Wrapper>
                {errorCode && <ErrorCode>{I18n.t('component:toast.error.code.errorCode', { errorCode })}</ErrorCode>}
                <Message>{I18n.t(`component:toast.${type}.message.${toastMessage}`)}</Message>
            </Wrapper>
        </ThemeProvider>,
        {className: `app-toast app-toast-${type}`}
    );
};

const StyledButton = styled.button`
    background: none;
    border: 0px solid transparent;
    &:focus {
        outline: none;
    }
`;

export const CloseButton = ({ closeToast }: any) => (
    <ThemeProvider theme={appTheme}>
        <StyledButton onClick={closeToast}>
            <Close />
        </StyledButton>
    </ThemeProvider>
);
